const ApprovalGrid = ({ data, tradeRequestAction }) => {
    const getFormattedValue = (label, value) => (Number.isNaN(Number(value)) || !label.startsWith('Notional'))
        ? value : Number(Number(value).toPrecision(3)).toLocaleString('en-US');

    const renderLabel = (label) => {
        if (!label.startsWith('Notional')) return label;

        const suffix = label.slice('Notional'.length);
        return (
            <>
                Notional
                {suffix && <span className="text-primary-100">{suffix}</span>}
            </>
        );
    };

    return (
        <div className="bg-gray-600 text-gray-100 rounded w-full border border-gray-400 my-3">
            <table className="border-collapse text-xs font-medium">
                <tbody>
                    {data?.map((row, index) => (
                        <tr key={index} className="border-b last:border-b-0 border-gray-400">
                            <td className="py-1 px-2 w-[120px] bg-gray-500 border-r border-gray-400">
                                {row.label.split(/(\([^)]*\))/).map((part, i) =>
                                    part.startsWith("(") && part.endsWith(")") ? (
                                        <span key={i} className="text-blue-400 font-semibold">{part}</span>
                                    ) : (
                                        <span key={i}>{part}</span>
                                    )
                                )}
                            </td>                            <td className="py-1 px-2">
                                {tradeRequestAction && row.requestedValue ? getFormattedValue(row.label, row.requestedValue) : getFormattedValue(row.label, row.value)
                                } <span
                                    className='text-warning-200'>{row.unit}</span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ApprovalGrid;
